<app-navbar title="Stopka"></app-navbar>
<ng-container *ngFor="let section of footerSections; let sectionIndex = index">
	<mat-expansion-panel [expanded]="true" class="my-3 section">
		<mat-expansion-panel-header>
			<mat-panel-title>
				<h4>{{ section.name }}</h4>
			</mat-panel-title>
		</mat-expansion-panel-header>
		<div class="d-flex justify-content-end pb-3">
			<button
				*ngIf="!section.editable; else editButtons"
				(click)="changeEditState(sectionIndex)"
				class="editBtn"
				mat-raised-button
				color="primary"
			>
				Edytuj
			</button>
			<ng-template #editButtons>
				<button
					(click)="addItem(sectionIndex); table.renderRows()"
					mat-raised-button
					class="addBtn"
					color="primary"
				>
					Dodaj
				</button>
				<button (click)="submit(sectionIndex)" class="ms-2" mat-raised-button color="primary">Zapisz</button>
			</ng-template>
		</div>

		<mat-table
			#table
			cdkDropList
			(cdkDropListDropped)="drop($event, sectionIndex); table.renderRows()"
			[dataSource]="section.footerItem"
			class="mat-elevation-z8 custom-mat-table"
		>
			<ng-container matColumnDef="name">
				<mat-header-cell *matHeaderCellDef>Nazwa</mat-header-cell>
				<mat-cell *matCellDef="let element; let i = index">
					<mat-form-field *ngIf="section.editable; else name" appearance="fill">
						<input matInput placeholder="Nazwa" [formControl]="inputControlsArrays[sectionIndex][i].name" />
						<mat-error *ngIf="inputControlsArrays[sectionIndex][i].name.invalid">
							To pole nie może być puste</mat-error
						>
					</mat-form-field>

					<ng-template #name>
						{{ element.name }}
					</ng-template>
				</mat-cell>
			</ng-container>
			<ng-container matColumnDef="link">
				<mat-header-cell *matHeaderCellDef>Link</mat-header-cell>
				<mat-cell style="height: 70px" *matCellDef="let element; let i = index">
					<mat-form-field *ngIf="section.editable; else link" appearance="fill">
						<input matInput placeholder="Link" [formControl]="inputControlsArrays[sectionIndex][i].link" />
						<mat-error *ngIf="inputControlsArrays[sectionIndex][i].link.invalid"
							><span
								>{{
									inputControlsArrays[sectionIndex][i].link.hasError('required')
										? 'To pole nie może być puste'
										: 'Nieprawidłowy format linku'
								}}
							</span>
						</mat-error>
					</mat-form-field>
					<ng-template #link>
						<a [href]="element.link" target="_blank">{{ element.link }}</a>
					</ng-template>
				</mat-cell>
			</ng-container>
			<ng-container matColumnDef="isActive">
				<mat-header-cell *matHeaderCellDef>Aktywny</mat-header-cell>
				<mat-cell *matCellDef="let element; let i = index">
					<mat-slide-toggle
						[disabled]="!section.editable"
						[(ngModel)]="element.isActive"
						color="primary"
					></mat-slide-toggle
				></mat-cell>
			</ng-container>
			<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
			<mat-row
				*matRowDef="let row; columns: displayedColumns; let i = index"
				[cdkDragDisabled]="!section.editable"
				cdkDrag
			>
			</mat-row>
		</mat-table>
	</mat-expansion-panel>
</ng-container>
